import { ApiService } from 'src/app/_Core/_Services/api.service';
import { Component, OnInit } from '@angular/core';
import { APIs } from 'src/app/_Core/_Constants/api.constant';

@Component({
  standalone: false,
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  token: string = '';
  contactDetails: { call: string, email: string, address: { buildingName: string, area: string, city: string, pinCode: string } } = { call: '', email: '', address: { buildingName: '', area: '', city: '', pinCode: '' } };
  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.fetchContactDetails();
  }

  fetchContactDetails() {
    let locationId = localStorage.getItem("locationId");
    // const url = APIs.getContactsData;
    const url = APIs.getContactsData + '?locationId=' + locationId;

    this.apiService.get(url, '').subscribe(
      (response: any) => {
        this.contactDetails.call = response.data.contactNumber;
        this.contactDetails.email = response.data.emailId;
        this.contactDetails.address.buildingName = response.data.buildingName;
        this.contactDetails.address.area = response.data.area;
        this.contactDetails.address.city = response.data.city;
        this.contactDetails.address.pinCode = response.data.pincode;
      },
      err => console.log('error', err)
    );
  }

}
